import React, { useMemo } from "react";
import styles from "./CompleteSamplingEventModal.module.css";

export const CompleteSamplingEventModal = ({
  isOpen,
  onClose,
  onConfirm,
  samplingEventData,
  allEmployees,
  user,
}) => {
  const samplingEventWells =
    (samplingEventData && samplingEventData.samplingEventWells) || [];

  const { uninspected, unsampled } = useMemo(() => {
    const uninspectedList = [];
    const unsampledList = [];
    for (const well of samplingEventWells) {
      if (!well.inspectionCompleted) uninspectedList.push(well.wellId);
      if (!well.samplingCompleted) unsampledList.push(well.wellId);
    }
    return { uninspected: uninspectedList, unsampled: unsampledList };
  }, [samplingEventWells]);

  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm?.(user?.employee_id || null);
  };

  const handleOverlayClick = (e) => {
    if (e && e.target === e.currentTarget) onClose?.();
  };

  return (
    <div className={styles.modalOverlay} onClick={handleOverlayClick}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h3>Complete Sampling Event</h3>
          <button className={styles.closeButton} onClick={onClose}>
            ×
          </button>
        </div>
        <div className={styles.modalBody}>
          <p className={styles.warningText}>
            Are you sure you want to mark this sampling event as complete?
          </p>

          <div className={styles.section}>
            <h4>Wells not inspected</h4>
            {uninspected.length > 0 ? (
              <ul className={styles.list}>
                {uninspected.map((id) => (
                  <li key={`ui-${id}`}>{id}</li>
                ))}
              </ul>
            ) : (
              <div className={styles.noData}>All wells inspected</div>
            )}
          </div>

          <div className={styles.section}>
            <h4>Wells not sampled</h4>
            {unsampled.length > 0 ? (
              <ul className={styles.list}>
                {unsampled.map((id) => (
                  <li key={`us-${id}`}>{id}</li>
                ))}
              </ul>
            ) : (
              <div className={styles.noData}>All wells sampled</div>
            )}
          </div>

          <div className={styles.note}>
            Completed date/time will be recorded and the sampling event will be
            marked completed.
          </div>

          <div className={styles.modalActions}>
            <button className={styles.cancelButton} onClick={onClose}>
              Cancel
            </button>
            <button className={styles.confirmButton} onClick={handleConfirm}>
              Mark Complete
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
